export default __webpack_public_path__ + "static/media/cancel_icon.9f060720.png";